import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../../services/auth.service';
import {PetService} from '../../../services/pet.service';
import {GeneralService} from '../../../services/general.service';
import {AppSettingsService} from '../../../services/app-settings.service';
import {StaticMethods} from '../../../model/GeneralModels';
import {PetOffer} from '../../../model/PetModel';

@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrls: [
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/css/light.theme.css'
  ],
  styles: [`
    .main .offer .offers .info .row .col {
      white-space: normal;
    }
  `]
})
export class OffersComponent implements OnInit {
  productName = 'PET';
  viewList: any = {};
  formsData: any = {};
  translation: any = {};
  basicInformation: any = {};
  private offerIdFormControl: FormControl = new FormControl([''], Validators.required);
  companies: string[] = [];
  companyOffers: any = {};
  formGroup: FormGroup = new FormGroup({
    companyName: new FormControl('', Validators.required),
    offerID: this.offerIdFormControl
  });

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private authService: AuthService,
              private petService: PetService,
              private generalService: GeneralService,
              public settings: AppSettingsService) {
  }

  ngOnInit(): void {
    if (StaticMethods.checkState(this.router, ['viewList', 'translation', 'formsData'],
      `/${this.productName}/basic-information`)) {
      this.viewList = history.state.viewList;
      this.formsData = history.state.formsData;
      this.translation = history.state.translation;
      this.getOffers();
    }
  }

  submit() {
    if (this.formGroup.valid) {
      const offerData = this.formGroup.value;
      console.log(this.formGroup.value);
      for (const offerDataKey in offerData) {
        if (offerData.hasOwnProperty(offerDataKey)) {
          this.formsData[offerDataKey] = offerData[offerDataKey];
        }
      }
      this.router.navigate([`/${this.productName}/confirm`], {
        state: {
          viewList: this.viewList,
          formsData: this.formsData,
          translation: this.translation
        }
      });
    }
  }

  onSelectionChange(offer) {
    const offerID = offer.id;
    this.viewList.offerName = offer.name;
    if (!this.formGroup.controls.offerID.value) {
      this.formGroup.controls.offerID.patchValue(offerID);
    }
    let element = document.getElementById(this.formGroup.controls.offerID.value + '');
    if (element) {
      element.style.display = 'none';
    }
    element = document.getElementById(offerID + '');
    element.style.display = 'block';
    this.formGroup.controls.offerID.patchValue(offerID);
  }

  getOffers() {
    this.petService.getOffers().subscribe(response => {
      if (response.success) {
        console.log('translation: ', this.translation);
        this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
        const companyOffersList = response.data;
        for (const companyOffersListKey in companyOffersList) {
          if (companyOffersList.hasOwnProperty(companyOffersListKey)) {
            this.companies.push(companyOffersListKey);
            this.companyOffers[companyOffersListKey] = [];
            companyOffersList[companyOffersListKey].forEach(offer => {
              this.companyOffers[companyOffersListKey].push(new PetOffer(offer));
            });
          }
        }
        this.formGroup.controls.companyName.patchValue(this.companies[0]);
      }
    }, error => {
      console.log(error);
    });
  }
}
